import { getPublicRuntimeConfig } from "../config";

const landingPageUrl = (): string => {
  const url = getPublicRuntimeConfig().landingPageUrl;
  if (url === undefined) {
    throw new Error("Missing landing page url");
  }

  return url;
};

const maintainXUrl = (): string => {
  const url = getPublicRuntimeConfig().maintainXUrl;
  if (url === undefined) {
    throw new Error("Missing maintainX url");
  }

  return url;
};

/**
 * @warning Webflow doesn't support trailing slashes in URLs
 */
export function getLandingPageUrl(path: string = "") {
  const baseUrl = landingPageUrl();

  // prevent double slashes, e.g. https://getmaintainx.com//about
  return ensureNoTrailingSlash(`${ensureNoTrailingSlash(baseUrl)}${ensureLeadingSlash(path)}`);
}

export function getMaintainXUrl() {
  const baseUrl = maintainXUrl();
  return ensureTrailingSlash(baseUrl);
}

export function getContactSalesUrl() {
  return getLandingPageUrl("/contact");
}

export function ensureTrailingSlash(url: string) {
  if (typeof url !== "string" || url.length === 0) {
    return url;
  }

  return url.endsWith("/") ? url : `${url}/`;
}

export function ensureNoTrailingSlash(url: string) {
  if (typeof url !== "string" || url.length === 0) {
    return url;
  }

  return url.endsWith("/") ? url.slice(0, -1) : url;
}

export function ensureLeadingSlash(url: string) {
  if (typeof url !== "string" || url.length === 0) {
    return url;
  }

  return url.startsWith("/") ? url : `/${url}`;
}

export function ensureNoLeadingSlash(url: string) {
  if (typeof url !== "string" || url.length === 0) {
    return url;
  }

  return url.startsWith("/") ? url.slice(1) : url;
}
